import React from "react";
import Layout from "../components/Layout";
import SalesDashboard from "../components/SalesDashboard/SalesDashboard";

const DashboardPage = () => {
  return (
    <Layout>
      <SalesDashboard />
    </Layout>
  );
};

export default DashboardPage;
